import React from 'react';
import {Script} from 'gatsby';
import {OPT_OUT_INLINE} from 'utils/privacy';

// Replaces gatsby-plugin-facebook-pixel so Limited Data Use can be set before init for
// opted-out visitors; client-side route changes fire facebook.viewContent() instead
const fbId = process.env.GATSBY_FB_PIXEL_ID;
const isProduction = process.env.NODE_ENV === 'production';
const fbScript = (!fbId || !isProduction) ? '' : `
if (typeof window !== "undefined") {
	!function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?
	n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;
	n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;
	t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,
	document,'script','https://connect.facebook.net/en_US/fbevents.js');
	if (${OPT_OUT_INLINE}) fbq('dataProcessingOptions', ['LDU'], 1, 1000);
	fbq('init', '${fbId}');
	fbq('track', 'PageView');
	fbq('track', 'ViewContent');
}`;

export const Facebook = () => {
	return <>{fbScript && <Script id='fb-pixel'>{fbScript}</Script>}</>;
};
